"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeLog = void 0;
// This is distributed to the frontend, just a simple auth, not very secure but one of the layers of our security onion.
// Security through obscurity isn't security - but it'll slow em down, we can rotate on a schedule and serve this via api or something etc.
// https://app.infisical.com/project/2047cd30-183d-4726-8421-2934b9a5b94b/secrets/overview
var LOGGING_SECRET = "EC996059-9BF2-4E54-9E2C-E28C4CC3CF60";
function backofficeLog(message, env) {
    if (env === "local") {
        console[message.level]("[".concat(message.timestamp, "]") + message.message, message.data);
    }
    else {
        setTimeout(function () {
            fetch("https://router.topiafi.com/prod/api/_logging/collect", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "fipreneurs-members-portal-".concat(env, ":").concat(LOGGING_SECRET),
                },
                body: JSON.stringify({
                    ts: message.timestamp,
                    m: message.message,
                    d: message.data,
                    l: message.level,
                }),
            });
        });
    }
}
exports.backofficeLog = backofficeLog;
